<p class="form-text text-muted title" title="E-mails administrativos são e-mails que você pode cadastrar para sempre aparecerem como sugestão para selecionar no envio de e-mails">
    <i class="far fa-envelope" aria-hidden="true"></i> Meus e-mails administrativos:
</p>  
<span
    *ngFor="let entity of entities"
    class="badge"
    [class.badge-secondary]="!entity.selected"
    [class.badge-primary]="entity.selected"
    (click)="toggle(entity)">
        {{entity.email}} <i class="fas fa-check" *ngIf="entity.selected"></i>
</span>
<p class="form-text text-muted" *ngIf="!entities || entities.length == 0">
    <i class="fas fa-info"></i> Nenhum e-mail cadastrado nos seus e-mails administrativos.
</p>
<small class="link-edit">
    <a href="./configuracoes/usuario-perfil"><i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar meus e-mails administrativos</a>
</small>